import { BybButtonChip } from "@Components/common/byb-ds";
import { NavSection } from "@Components/game";
import { ChallengeFilterDialog } from "@Components/game/challenges";
import PlaylistCard from "@Components/game/playlists/common/cards/playlist-card";
import PlaylistRowLarge from "@Components/game/playlists/common/playlist-row-large";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { formatTag } from "@Helpers/formatters";
import { usePlaylistCategory } from "@hooks/game/playlists/use-playlist-category-data";
import useI18n from "@i18n";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

const PageId = "PLAYLIST_CATEGORY";

const PlaylistCategory = () => {
  const { tag } = useParams<{ tag: string }>();
  const theme = useTheme();
  const { i18n } = useI18n();
  const { playlists, filterModalOpen, setFilterModalOpen, filters, setFilters } = usePlaylistCategory(tag!);

  return (
    <ContainerWrapper id={PageId} sx={{ overflow: "visible" }}>
      <Container maxWidth={false} disableGutters sx={{ padding: theme.spacing(0, 0, 6) }}>
        <PlaylistRowLarge 
          playlists={playlists.slice(0, 1)} 
          sx={{ 
            padding: theme.spacing(3, 0),
            marginBottom: theme.spacing(6)
          }} 
        />

        <NavSection 
          title={i18n("challenges.category.page.grid.title", { count: playlists?.length || 0 })}
          sx={{ padding: theme.spacing(6) }}
        >
          {filters.length > 0 && (
            <Stack 
              direction="row" 
              spacing={2} 
              sx={{ 
                marginBottom: theme.spacing(3),
                padding: theme.spacing(0, 6)
              }}
            >
              {filters.map((filter) => (
                <BybButtonChip key={filter} onClick={() => setFilterModalOpen(true)}>
                  {formatTag(filter)}
                </BybButtonChip>
              ))}
            </Stack>
          )}

          <Stack sx={{ padding: theme.spacing(0, 6) }}>
            <Grid container spacing={3}>
              {playlists.map((playlist) => (
                <Grid item xs={3} key={playlist.id}>
                  <PlaylistCard playlist={playlist} size="small" fullWidth />
                </Grid>
              ))}
            </Grid>
          </Stack>
        </NavSection>

        <ChallengeFilterDialog open={filterModalOpen} onClose={() => setFilterModalOpen(false)} onApply={setFilters} />
      </Container>
    </ContainerWrapper>
  );
};

export default PlaylistCategory;
